import React from 'react';
import CategoriesList from './list';

const CategoriesComponent = () => {
  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CategoriesList />
    </div>
  );
};

export default CategoriesComponent;
